import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Person } from '../models/person';
import { MessageService } from './message.service';
import { Observable } from 'rxjs';
import { ConfigLoaderService } from '../config/configloader.service';
import { map } from 'rxjs/operators';

/**
 * This class represents access to all rest requests concerning Person/Team data of the PyWall
 */
@Injectable()
export class PersonService {

  private projectBaseURL: string;

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private configService: ConfigLoaderService) {
    this.projectBaseURL = `${this.configService.settings.pyWallServer.url}projects`;
  }

  /**
   * Returns all members of a project
   */
  getMembers(projectKey: String): Observable<Person[]> {
    this.messageService.sendDebug(`PersonService getMembers called on project ${projectKey}`);
    const targetURL = this.projectBaseURL + `/${projectKey}/members/`;
    const apiResult: Observable<Person[]> = this.http.get<Person[]>(targetURL);
    return apiResult.pipe(map((people: Person[]) => people.map(person => Person.createFromPywallData(person))));
  }
}
